"use client";
import Link from "next/link";
import Menu from "@/components/common/Menu"
import Breadcrumb from "@/components/common/Breadcrumb"

export default function Footer({data}) {
  return (
    <footer className="footer">
      <div className="footer-inner">
        <Breadcrumb data={data} />
        <Menu />
      </div>
    </footer>
  );
}
